import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { Logger } from '@core/services/logger.service';

import { agGridEnterpriseLicence } from '@roomex/rx-components';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { CsvExportModule } from '@ag-grid-community/csv-export';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { environment, zonePendingTasks } from '@rx-applications/clientsite/shared/utils';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';

LicenseManager.setLicenseKey(agGridEnterpriseLicence);
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CsvExportModule,
  SetFilterModule,
  MenuModule,
  ServerSideRowModelModule,
]);

const logger = new Logger(module.id);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(zonePendingTasks)
  .catch((err) => logger.error(err));
